import _ from 'lodash';
import * as moment from 'moment';
import { isValid } from 'date-fns';
import * as yup from 'yup';
import { dependsOnModelRegex, dependsOnValuesRegex } from './constants';

export const validationError = errors => {
  let errorMessage = '';
  _.map(errors, obj => {
    _.map(obj, obj2 => {
      errorMessage += `${obj2.message}\n`;
    });
  });

  return errorMessage;
};

export const validateValues = (initErrors, value, type, maxLength, name) => {
  let errors = initErrors;
  if (type === 'string') {
    if (validateString(value, maxLength)) {
      if (!errors.includes(name)) {
        errors = [...errors, name];
      }
    } else {
      errors = errors.filter(item => item !== name);
    }
  } else if (type === 'integer') {
    if (validatePositiveInteger(value)) {
      if (!errors.includes(name)) {
        errors = [...errors, name];
      }
    } else {
      errors = errors.filter(item => item !== name);
    }
  } else if (type === 'float') {
    if (validatePositiveFloat(value)) {
      if (!errors.includes(name)) {
        errors = [...errors, name];
      }
    } else {
      errors = errors.filter(item => item !== name);
    }
  } else if (type === 'date') {
    if (!isValid(value)) {
      if (!errors.includes(name)) {
        errors = [...errors, name];
      }
    } else {
      errors = errors.filter(item => item !== name);
    }
  }

  return errors;
};

export const validateString = (string, maxLength) => {
  if (!_.isNull(string)) {
    if (string.length > maxLength) {
      return true;
    }
  }

  return false;
};

export const validatePositiveInteger = number => {
  if (!isPositiveInteger(number) || isNaN(number)) {
    return true;
  }

  return false;
};

export const validatePositiveFloat = number => {
  if (!isPositiveFloat(number) || isNaN(number)) {
    return true;
  }

  return false;
};

function isPositiveInteger(value) {
  // eslint-disable-next-line prefer-named-capture-group
  return (/^(\s*|\d+)$/).test(value);
}

function isPositiveFloat(value) {
  // eslint-disable-next-line prefer-named-capture-group
  return (/^(((?!00)\d*)(\.\d+)?){1}$/gm).test(value);
}

export const formatDateTime = date => {
  if (date) {
    if (date instanceof Date) {
      if (isNaN(date)) {
        return null;
      }
      const dateFormatted = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
      const split = dateFormatted.toISOString().split('T');

      return `${split[0]} ${split[1].substring(0, 8)}`;
    }
    const split = date.split('T');
    if (split.length > 1) {
      return `${split[0]} ${split[1].substring(0, 8)}`;
    }

    return date;

  }

  return null;

};

export const formatDate = date => {
  if (date) {
    if (date instanceof Date) {
      if (isNaN(date)) {
        return null;
      }
      const dateFormatted = new Date(date.getTime() - date.getTimezoneOffset() * 60000);

      return dateFormatted.toISOString().split('T')[0];
    }

    return date.split('T')[0];
  }

  return null;

};

export const formatTime = date => {
  if (date) {
    if (date instanceof Date) {
      if (isNaN(date)) {
        return null;
      }
      const dateFormatted = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
      const split = dateFormatted.toISOString().split('T');

      return split[1].substring(0, 5);
    }

    return moment(date, 'HH:mm:ss');
  }

  return null;

};

export const validateRequiredFields = (initRequiredFields, value, name, required) => {
  if (!required) {
    return initRequiredFields;
  }
  let requiredFields = initRequiredFields;
  if (_.isNil(value) || _.isNull(value) || (typeof (value) === 'string' && _.isEmpty(value))) {
    if (!requiredFields.includes(name)) {
      requiredFields = [...requiredFields, name];
    }
  } else {
    requiredFields = requiredFields.filter(item => item !== name);
  }

  return requiredFields;
};

export const createYupSchema = (schema, config) => {
  if (config.show_on !== null) {
    config.required = true;
    config.validations.push({ 'type': 'required', 'params': ['To pole jest wymagane'] });
  }

  const { name, validation_type, validations = [] } = config;
  if (!yup[validation_type]) {
    return schema;
  }
  let validator = yup[validation_type]();
  validations.forEach(validation => {
    const { params, type } = validation;
    if (!validator[type]) {
      return;
    }
    if (type === 'oneOf') {
      if (_.isString(params[0][0]) && params[0][0].startsWith('ref:')) {
        params[0][0] = yup.ref(params[0][0].split(':')[1]);
      }
    }
    validator = validator[type](...params);
  });
  schema[name] = validator;

  return schema;
};


/**
 * @param {String} dependsOn model-identifier string, eg season-z_21
 * @returns {[String, null]} exported identifier from dependsOn
 */
export const constructIdentifier = dependsOn => {
  const model = getDependsOnModel(dependsOn.replace('\n', '').split(' '));
  if (!_.isEmpty(model)) {
    return model[0].split('-')[1].replace(/\s/g, '');
  }

  return null;
};


/**
 * @param {String} strValue some string value
 * @param {String} regexPattern some regex pattern to test
 * @returns {String} boolean
 */
export const regexCustomValidations = (strValue, regexPattern) => {
  const regObj = new RegExp(regexPattern);

  return regObj.test(strValue);
};


/**
 * @param {String} dependsOn some string from json form schema
 * @returns {Array} empty array or first argument as model
 */
export const getDependsOnModel = dependsOn => _.filter(dependsOn, obj => obj.match(dependsOnModelRegex));


/**
 * Get all dependsOn values
 * @param {String} dependsOn some string from json form schema
 * @returns {Array} empty array or array of dependant values
 */
export const getDependsOnValues = dependsOn => {
  if (!_.isNil(dependsOn)) {
    return _.filter(dependsOn.trim().replace('\n', '')
      .split(' '), obj => obj.match(dependsOnValuesRegex));
  }

  return [];
};


/**
 * Get first dependsOn value
 * @param {String} dependsOn some string from json form schema
 * @returns {Array} empty array or array of dependant values
 */
export const getDependsOnValue = dependsOn => {
  if (!_.isNil(dependsOn)) {
    const values = _.filter(dependsOn.trim().replace('\n', '')
      .split(' '), obj => obj.match(dependsOnValuesRegex));
    if (!_.isEmpty(values)) {
      return values[0];
    }
  }

  return '';
};


/**
 * @param {String} dependsOn some string from json form schema
 * @param {[String, null]} rootFieldName root field name or null
 * @param {Object} formikValues formik values object
 * @returns {String} params
 */
export const constructDependsOnParams = (dependsOn, rootFieldName, formikValues) => {
  if (!_.isNil(formikValues[rootFieldName]) && !_.isEmpty(formikValues[rootFieldName])) {
    const values = getDependsOnValues(dependsOn);
    let params = `${rootFieldName}=${formikValues[rootFieldName]}&`;
    params += `root_name=${rootFieldName}&`;
    _.forEach(values, fieldName => {
      params += `${fieldName}=${formikValues[fieldName]}&`;
    });

    return params;
  }

  return null;
};


/**
 * @param {String} showOn show_on values from json form schema
 * @param {Object} formikValues formik values object
 * @param {Object} field showOn field object
 * @returns {Boolean} can show
 */
export const handleShowOn = (showOn, formikValues, field) => {
  if (_.isNil(showOn) || _.isEmpty(showOn)) {
    return true;
  }

  const args = showOn.trim().split(' ');

  const result = [];
  const argsNames = [];

  for (const arg of args) {
    const currentArg = arg.split('-');
    currentArg[0] = currentArg[0].replace('\n', '');

    if (!argsNames.includes(currentArg[0])) {
      argsNames.push(currentArg[0]);
    }

    if (currentArg[1] === 'exists') {
      result.push(!_.isEmpty(formikValues[currentArg[0]]));
    } else if (currentArg[1] === 'false') {
      result.push(!formikValues[currentArg[0]]);
    } else if (currentArg[1] === 'true') {
      result.push(formikValues[currentArg[0]]);
    } else if (currentArg[1].includes('option_')) {
      if (typeof field.options[0] === 'object') {
        result.push(_.findIndex(field.options, obj => obj.id === formikValues[currentArg[0]]) == currentArg[1].slice(-1));
      }
      result.push(field.options.indexOf(formikValues[currentArg[0]]) == currentArg[1].slice(-1));
    }
  }

  return result.filter(item => item === true).length === argsNames.length;
};


/**
 * @param {Integer} int some number between 0 and 1t
 * @returns {String} percent representation of given number
 */
export const numberToPercent = int => `${int * 100}%`;


/**
 * @param {String} params params as string
 * @returns {Array} array of params
 */
export const setEmptyChoicesFunction = params => params.trim().split(',');

/**
 * @param {String} params params as string
 * @returns {Array} array of params
 */
export const setRequiredFieldsFunction = params => params.trim().split(',');


/**
 * @param {String} params params as string
 * @returns {Array} array of params
 */
export const setBigFamilyCardFunction = params => params.trim().split(',');


/**
 * @param {Object} dynamicFunction function name
 * @param {Object} formik formik object
 * @param {Object} field form field object
 * @param {Any} val new field value
 * @returns {Array} array of params
 */
export const handleDynamicFunction = (dynamicFunction, formik, field, val) => {
  if (dynamicFunction.functionName === 'setEmptyChoicesFunction') {
    const newObjects = {};
    _.forEach(dynamicFunction.data, item => {
      newObjects[item] = '';
    });
    newObjects[field.name] = val;
    formik.setValues({ ...formik.values, ...newObjects });

    return { callback: null };
  } else if (dynamicFunction.functionName === 'setRequiredFieldsFunction') {
    formik.setFieldValue(field.name, val);
    if (dynamicFunction.data[0].includes('true') || dynamicFunction.data[0].includes('false')) {
      return { callback: 'yupRequiredFieldsCallback', data: val };
    }

    return { callback: 'yupRequiredFieldsCallback', data: dynamicFunction.data };
  } else if (dynamicFunction.functionName === 'setBigFamilyCardFunction') {
    formik.setFieldValue(field.name, val);
    if (dynamicFunction.data.includes('true') || dynamicFunction.data.includes('false')) {
      return { callback: 'bigFamilyCardCallback', data: val };
    }

    return { callback: 'bigFamilyCardCallback', data: dynamicFunction.data };
  }
};

/**
 * @param {String} option option as string
 * @returns {Array} array of options
 */
export const getOptionIndex = option => {
  if (option === undefined) {
    return;
  }

  return option.split('-')[1].split('_')[1];
};

/**
 * @param {Date} date date object
 * @param {Integer} days days to add
 * @returns {Date} formatted date object
 */
export const addDays = (date, days) => {
  const result = new Date(date);
  result.setDate(result.getDate() + days);

  return result;
};

/**
 * @param {Array} payments wszystkie oplaty z zamowienia
 * @returns {number} calosc zadluzenia
 */
export const calculateDebt = payments => {
  let value = 0.0;
  payments.filter(p => !p.paid && !p.deleted)
    .forEach(p => {
      value += p.to_pay;
    });

  return `${value} zł`;
};
